/** @format */

export const debounce = (func: Function, time = 300, immediate = false) => {
	let timer: number | null = null;
	return (...args: any) => {
		if (timer) clearInterval(timer);
		if (immediate) {
			if (!timer) func(...args);
			timer = window.setTimeout(() => {
				timer = null;
			}, time);
		} else {
			timer = window.setTimeout(() => {
				func(...args);
			}, time);
		}
	};
};
